import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClasseFabbricato } from '../models/classe-fabbricato';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class ClasseFabbricatoService extends ResourcefulService<ClasseFabbricato>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, ClasseFabbricato);
    }

    async findByName(nome: string): Promise<ClasseFabbricato | null> {
        try {
            const items = await this.getAll();
            return items.find(item => 
                item.nome?.toLowerCase() === nome.toLowerCase()
            ) || null;
        } catch (error) {
            console.error('Error finding ClasseFabbricato by name:', error);
            return null;
        }
    }
}
